import React from 'react';
import { FaUser, FaBox, FaMapMarkerAlt, FaSignOutAlt } from 'react-icons/fa';
import { NavLink, useLocation } from 'react-router-dom';
import ConfirmationModal from './ConfirmationModal';
import UseNavigation from './UseNavigation';

const navItems = [
  { name: 'Profile', icon: <FaUser />, path: '/user/profile' },
  {
    name: 'Order History',
    icon: <FaBox />,
    path: '/orders/history',
    matchPaths: ['/orders/history', '/orders/details/:orderId'],
  },
  {
    name: 'Address',
    icon: <FaMapMarkerAlt />,
    path: '/user/address',
    matchPaths: ['/user/address', '/user/create-address', '/user/edit-address/:addressId'],
  },
  // { name: "Settings", icon: <FaCog />, path: "/settings" },
  { name: 'Log-out', icon: <FaSignOutAlt />, path: '/logout', isLogout: true },
];

const Navigation = () => {
  const { logout, showConfirmModalLogout, showLogoutConfirmModal, setShowConfirmModalLogout } = UseNavigation();
  const location = useLocation();
  const currentPath = location.pathname;

  const isItemActive = (item: any) => {
    if (currentPath === item.path) return true;
    if (item.matchPaths) {
      return item.matchPaths.some((match: any) => {
        if (match.includes(':addressId')) {
          return currentPath.startsWith('/user/edit-address/');
        }

        if (match.includes(':orderId')) {
          return currentPath.startsWith('/orders/details/');
        }
        return currentPath === match;
      });
    }
    return false;
  };

  return (
    <>
      <div className='hidden sm:hidden md:hidden lg:block w-full h-fit sm:w-1/5 md:w-1/4 lg:w-1/5 bg-white rounded-xl shadow-md border font-poppins'>
        <h2 className='text-xl font-medium p-4'>Navigation</h2>
        <ul className='space-y-3'>
          {navItems.map(item => {
            const active = isItemActive(item);

            if (item.isLogout) {
              return (
                <li key={item.name}>
                  <button
                    onClick={() => showLogoutConfirmModal()}
                    className='w-full text-left font-poppins text-base flex items-center space-x-3 px-4 py-2 hover:bg-[#C12E2A1A] transition text-[#999999]'
                  >
                    {item.icon}
                    <span>{item.name}</span>
                  </button>
                </li>
              );
            }

            return (
              <li key={item.name}>
                <NavLink
                  to={item.path}
                  className={`font-poppins text-base flex items-center space-x-3 px-4 py-2 transition ${
                    active
                      ? 'bg-[#C12E2A1A] border-l-4 border-[#C12E2A] text-[#C12E2A]'
                      : 'text-[#999999] hover:bg-[#C12E2A1A]'
                  }`}
                >
                  {item.icon}
                  <span>{item.name}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
        {showConfirmModalLogout && (
          <ConfirmationModal logout={logout} setShowConfirmModalLogout={setShowConfirmModalLogout} />
        )}
      </div>
    </>
  );
};

export default Navigation;
